import {
  AfterViewInit,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { Editor, EditorModule } from "primeng/editor";
import { UpdateNotificationEmailDto } from "../../../core/models/project-workflow/updateNotificationEmailDto";
import { CommonService } from "../../../core/services/common.service";
import { SharedService } from "../../../core/services/shared.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { DialogModule } from "primeng/dialog";
import { CommonModule } from "@angular/common";
import { Select, SelectChangeEvent, SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { DividerModule } from "primeng/divider";
import { ChatGptRequestDto } from "../../../core/models/common/chatGptRequestDto";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-notification-email-setting",
  templateUrl: "./notification-email-setting.component.html",
  styleUrls: ["./notification-email-setting.component.scss"],
  imports: [
    DialogModule,
    CommonModule,
    SelectModule,
    FormsModule,
    EditorModule,
    OverlayPanelModule,
    DividerModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class NotificationEmailSettingComponent
  implements AfterViewInit, DoCheck
{
  @Input() viewEmailSettingsModal = false;
  @Input() notificationEmailData = {} as UpdateNotificationEmailDto;
  @Output() updateEmailDataEvent =
    new EventEmitter<UpdateNotificationEmailDto>();
  @Output() closeModalEvent = new EventEmitter();
  @Output() hasUnsavedChangesEvent = new EventEmitter<boolean>();

  constructor(
    private _commonService: CommonService,
    private _toastr: JniToastrService,
    private _sharedService: SharedService
  ) {}

  displayChatGPTModal = false;
  hintDailog = false;
  showSmallLoader = false;
  chatGPTPrompt = "";
  tagValue: string | null = "";

  tagList = [
    "$Owner$",
    "$Client$",
    "$JobName$",
    "$ProjectNumber$",
    "$TrackingNumber$",
    "$CompanyName$",
    "$NickName$",
  ];

  @ViewChild("tagSelector") tagSelector!: Select;
  lastSelectedTagOption: string | null = null;
  selectionStart = 0;
  selectionLength = 0;
  prevNotificationEmailData = {} as UpdateNotificationEmailDto;

  closeModal() {
    this.displayChatGPTModal = false;
    this.closeModalEvent.emit();
  }

  updateEmailNotificaitionData() {
    this.updateEmailDataEvent.emit(this.notificationEmailData);
  }

  showOrHideChatGPTModal() {
    this.displayChatGPTModal = !this.displayChatGPTModal;
  }

  showChatGptHintDialog() {
    this.hintDailog = !this.hintDailog;
  }

  postChatGPTRequest() {
    this.showSmallLoader = true;
    if (!this.chatGPTPrompt || this.chatGPTPrompt === "") {
      this._toastr.error("Error", "Prompt cannot be empty");
      this.showSmallLoader = false;
      return;
    }

    const payload = {
      messages: [
        {
          role: "user",
          content: this.chatGPTPrompt,
        },
      ],
    } as ChatGptRequestDto;
    this._commonService.postChatGPTRequest(payload).subscribe({
      next: res => {
        if (res?.data) {
          this.notificationEmailData.content = res?.data;
        }
        this.chatGPTPrompt = "";
        this.displayChatGPTModal = false;
        this.showSmallLoader = false;
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Data from Chat GPT");
        this.displayChatGPTModal = true;
        this.showSmallLoader = false;
      },
    });
  }

  /* eslint-disable @typescript-eslint/no-unsafe-call */
  onChangeAddTag(editorRef: Editor, event: SelectChangeEvent) {
    if (!editorRef) return;

    const editor = editorRef.getQuill();
    const selection = editor.getSelection();
    const textLength = editor.getLength();

    if (!selection && this.selectionStart === 0) {
      this.selectionStart = textLength;
      this.selectionLength = 0;
    }

    const position = this.selectionStart;
    const length = this.selectionLength;
    if (length > 0) {
      editor.deleteText(position, length);
    }
    editor.insertText(this.selectionStart, event);

    editor.setSelection(position + event.value.length);
    this.lastSelectedTagOption = event.value;
    this.tagValue = null;
    //this.tagSelector.setValue(null);
    this.selectionStart = position + event.value.length;
    this.selectionLength = 0;
    this.notificationEmailData.content = editor.root.innerHTML;
  }

  getCursorPostion(editorRef: Editor) {
    const editor = editorRef.getQuill();
    const selection = editor.getSelection();
    if (selection) {
      this.selectionStart = selection?.index ?? 0;
      this.selectionLength = selection?.length ?? 0;
    }
  }
  /* eslint-enable @typescript-eslint/no-unsafe-call */

  ngDoCheck() {
    if (
      this.notificationEmailData.content !== "" &&
      this.prevNotificationEmailData.content !== ""
    ) {
      const check = this._sharedService.deepCompare(
        this.notificationEmailData,
        this.prevNotificationEmailData
      );
      if (check) {
        this.hasUnsavedChangesEvent.emit(true);
      }
    }
  }

  ngAfterViewInit(): void {
    this.prevNotificationEmailData = this.notificationEmailData;
  }
}
